// Helpery do obsługi plików i załączników

/**
 * Konwertuje ArrayBuffer do base64 string
 * @param arrayBuffer - zawartość pliku jako ArrayBuffer
 * @returns base64 string
 */
export const arrayBufferToBase64 = (arrayBuffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(arrayBuffer);
  const binary = bytes.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
  return btoa(binary);
};

/**
 * Konwertuje File do ArrayBuffer
 * @param file - obiekt File
 * @returns Promise z ArrayBuffer
 */
export const fileToArrayBuffer = (file: File): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

/**
 * Waliduje typ pliku
 * @param file - obiekt File
 * @param allowedTypes - tablica dozwolonych rozszerzeń (np. ['.pdf', '.docx'])
 * @returns true jeśli typ jest dozwolony
 */
export const isFileTypeAllowed = (file: File, allowedTypes: string[]): boolean => {
  const fileName = file.name.toLowerCase();
  return allowedTypes.some(type => fileName.endsWith(type));
};

/**
 * Formatuje rozmiar pliku do czytelnej formy
 * @param bytes - rozmiar w bajtach
 * @returns sformatowany string (np. "1.5 MB")
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

